import React from 'react';
import { Button, IconButton, useMediaQuery, useDisclosure } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { getIsPageBarOpen } from 'redux/DashboardSliceV2';
import DownloadIcon from 'components/Icons/DownloadIcon';
import DashboardExportPanel from 'pages/ModelOverviewPage/DashboardRevamp/Export/DashboardExportPanel';
import { isReportPacksEnabled } from 'utils/reportPacksFlag';

import PreviewModal from './PreviewModal';

const ExportButtonNew = () => {
  const flags = useFlags();
  const isPageBarOpen = useSelector(getIsPageBarOpen);
  const [smallDevice] = useMediaQuery('(max-width: 1100px)');
  const isSmallDevice = (smallDevice && isPageBarOpen) || smallDevice;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const serverPackExport = isReportPacksEnabled(flags);

  return (
    <>
      {isSmallDevice ? (
        <IconButton
          aria-label='Export'
          icon={<DownloadIcon />}
          backgroundColor='#5A58AB'
          borderRadius='sm'
          height='40px'
          border='none'
          fontSize='md'
          fontWeight='400'
          width='fit-content'
          title='Export'
          padding='.5rem 1rem'
          color='white'
          onClick={onOpen}
        />
      ) : (
        <Button
          backgroundColor='#5A58AB'
          borderRadius='sm'
          height='40px'
          leftIcon={<DownloadIcon />}
          fontSize='md'
          border='none'
          fontWeight='400'
          width='fit-content'
          title='Export'
          padding='.5rem 1rem'
          color='white'
          onClick={onOpen}
        >
          Export
        </Button>
      )}

      {serverPackExport ? (
        <DashboardExportPanel isOpen={isOpen} onClose={onClose} />
      ) : (
        <PreviewModal isOpen={isOpen} onClose={onClose} selectedPages={[]} />
      )}
    </>
  );
};

export default ExportButtonNew;
